<template>
  <div class="charcounter" :class="status">
    <span class="remainingChars">{{ remainingChars }}</span>
    <svg
        class="counter"
        viewBox="0 0 33.83098862 33.83098862"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
    >
      <circle
          class="counterUnderlay"
          cx="16.91549431"
          cy="16.91549431"
          r="15.91549431"
          fill="none"
          stroke-width="2"
      />
      <circle
          class="counterProgress"
          :stroke-dasharray="`${ perc },100`"
          cx="16.91549431"
          cy="16.91549431"
          r="15.91549431"
          fill="none"
          stroke-width="4"
      />
    </svg>
  </div>
</template>

<script>
	export default {
		name: "CharCounter",
		props: {
			remainingChars: {
				type: Number,
				default: 280,
			},
			perc: {
				type: Number,
				default: 0,
			},
			warningLimit: {
				type: Number,
				default: 20,
			}
		},
		computed: {
			status() {
				return {
					'empty': this.remainingChars === 280,
					'too-long': this.remainingChars < 0,
					'warning': this.remainingChars >= 0 && this.remainingChars <= this.warningLimit,
				}
			},
		}
	}
</script>

<style lang="scss" scoped>

  .charcounter {
    display: flex;
    align-items: center;
  }

  .remainingChars {
    margin-right: 0.5em;
    color: gray;
    font-size: 0.75em;
  }

  .counter {
    overflow: visible;
    transform: rotate(-90deg);
    transform-origin: center;
  }

  .counterUnderlay {
    stroke: lightgray;
  }

  .counterProgress {
    stroke: blue;
  }

  .empty {
    display: none;
  }

  .too-long {
    .remainingChars {
      color: #f14668;
    }
    .counterProgress {
      stroke: #f14668;
    }
  }

  .warning {
    .remainingChars {
      color: darkorange;
    }
    .counterProgress {
      stroke: darkorange;
    }
  }

</style>
